export const environment = {
  production: false,
  'API_URL': 'https://api.innovation-csai.karazin.ua',
  'GOOGLE_CLIENT_ID': 'valid-client-id',
  'CLIENT_URL': 'https://innovation-csai.karazin.ua',
  'BASE_LANGUAGE': 'UA',
  'AVAILABLE_LANGUAGES': 'UA,EN'
};
